/**
 * /tenants/$slug/agents/approval-history — thin route shim. Domain logic lives in
 * features/agent-approval-history/. (Relocates under "Agent governance" in the P1 nav restructure.)
 */

import { createFileRoute } from "@tanstack/react-router";
import {
  approvalHistorySearchSchema,
  type ApprovalHistorySearch,
} from "@/features/agent-approval-history/schemas";
import { fetchApprovalHistory } from "@/features/agent-approval-history/queries";
import { queryKeys } from "@/lib/query-keys";
import { ApprovalHistoryPage } from "@/features/agent-approval-history/pages/approval-history-page";

export const Route = createFileRoute("/_authed/tenants/$slug/agents/approval-history")({
  validateSearch: (raw: Record<string, unknown>): ApprovalHistorySearch =>
    approvalHistorySearchSchema.parse(raw),
  loaderDeps: ({ search }) => ({ search }),
  loader: ({ context, deps }) =>
    context.queryClient.ensureQueryData({
      queryKey: queryKeys.agents.approvalHistory(context.tenant.id, deps.search),
      queryFn: () => fetchApprovalHistory(context.tenant.id, deps.search),
    }),
  component: ApprovalHistoryPage,
});
